import { TemplatePlaceholder } from './templatePlaceholder.js';
import { SlottedTemplate } from './slottedTemplate.js';

export class SlotPlaceholder {
    nestedSlots: SlotPlaceholder[] = [];
    number: string = '';
    startIndex: number = 0;
    endIndex: number = 0;
    content: string = '';
    slotKey: string = '';
    openTag: string = '';
    closeTag: string = '';
    nestedPlaceholders: TemplatePlaceholder[] = [];
    nestedSlottedTemplates: SlottedTemplate[] = [];
    hasNestedPlaceholders: boolean = false;
    hasNestedSlottedTemplates: boolean = false;
    requiresNestedProcessing: boolean = false;

    constructor() {}
}
